import { cn } from "@/utils/cn";
import { memo } from "react";

interface HouseIconProps {
  className?: string;
}

export const HouseIcon = memo(function HouseIcon({ className }: HouseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cn("fill-white", className)}
    >
      <g clipPath="url(#clip0_5071_3770)">
        <path d="M22.4301 19.4393H20.9348V12.7103L21.1535 12.929C21.294 13.0693 21.4845 13.148 21.6831 13.1478C21.8817 13.1477 22.0721 13.0686 22.2124 12.9281C22.3527 12.7875 22.4314 12.597 22.4312 12.3984C22.431 12.1998 22.352 12.0095 22.2114 11.8692L13.0198 2.6803C12.7394 2.40009 12.3592 2.24268 11.9627 2.24268C11.5663 2.24268 11.1861 2.40009 10.9057 2.6803L1.71405 11.8692C1.57388 12.0095 1.49518 12.1997 1.49527 12.398C1.49535 12.5963 1.57422 12.7865 1.71451 12.9267C1.85481 13.0668 2.04504 13.1455 2.24335 13.1454C2.44167 13.1454 2.63183 13.0665 2.772 12.9262L2.99069 12.7103V19.4393H1.49535C1.29706 19.4393 1.10688 19.5181 0.966668 19.6583C0.826453 19.7985 0.747681 19.9887 0.747681 20.187C0.747681 20.3853 0.826453 20.5755 0.966668 20.7157C1.10688 20.8559 1.29706 20.9347 1.49535 20.9347H22.4301C22.6284 20.9347 22.8186 20.8559 22.9588 20.7157C23.099 20.5755 23.1778 20.3853 23.1778 20.187C23.1778 19.9887 23.099 19.7985 22.9588 19.6583C22.8186 19.5181 22.6284 19.4393 22.4301 19.4393ZM4.48603 11.215L11.9627 3.73826L19.4394 11.215V19.4393H14.9534V14.2056C14.9534 14.0074 14.8747 13.8172 14.7344 13.677C14.5942 13.5368 14.404 13.458 14.2058 13.458H9.71973C9.52144 13.458 9.33126 13.5368 9.19105 13.677C9.05083 13.8172 8.97206 14.0074 8.97206 14.2056V19.4393H4.48603V11.215ZM13.4581 19.4393H10.4674V14.9533H13.4581V19.4393Z" />
      </g>
      <defs>
        <clipPath id="clip0_5071_3770">
          <rect width="23.9255" height="23.9255" />
        </clipPath>
      </defs>
    </svg>
  );
});
